import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { Link, Typography } from '@tkww/the-bash-frontend';
import { SectionContainer } from 'components/grid';
import { ctaClickEvent } from 'state/modules/analytics';
import { RISING_STAR_CLICK_TARGET, HYPERLINK_CTA_STYLE } from 'analytics/constants';
import { RISING_STAR_PAGE_NAME } from 'constants/pageNames';
import { winnerPropType } from 'views/RisingStarPage/propTypes';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '0 0 8px 10px',
  [`&.${tableCellClasses.body}`]: {
    borderBottom: 'none',
  },
  [theme.breakpoints.up('md')]: {
    padding: 16,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  display: 'grid',
  backgroundColor: '#FFF',
  padding: '8px 0',
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.grey[200],
  },
  [theme.breakpoints.up('md')]: {
    display: 'table-row',
  },
}));

const AwardGroupWinnerList = ({ awardGroupName, winners, year }) => {
  const dispatch = useDispatch();

  const dispatchVendorClickEvent = (vendor) => {
    const clickTarget = RISING_STAR_CLICK_TARGET(year);
    dispatch(
      ctaClickEvent(vendor.profileName, clickTarget, {
        clickStyle: HYPERLINK_CTA_STYLE,
        name: RISING_STAR_PAGE_NAME,
      })
    );
  };

  return (
    awardGroupName &&
    !isEmpty(winners) && (
      <SectionContainer sx={{ textAlign: 'center', marginBottom: '48px' }}>
        <Typography sx={{ marginBottom: '16px' }} variant="h3">
          {awardGroupName}
        </Typography>
        <TableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableBody>
              {winners.map((winner) => (
                <StyledTableRow key={winner.profileName}>
                  <StyledTableCell>
                    <Typography sx={{ fontWeight: 800 }} variant="body1">
                      {winner.category}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Link path={winner.profileUrl} onClick={() => dispatchVendorClickEvent(winner)}>
                      <Typography
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                        variant="body1"
                      >
                        {winner.profileName}
                      </Typography>
                    </Link>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography variant="body1">
                      {winner.city}, {winner.state}
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SectionContainer>
    )
  );
};

AwardGroupWinnerList.propTypes = {
  awardGroupName: PropTypes.string,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  winners: PropTypes.arrayOf(winnerPropType),
};

export default AwardGroupWinnerList;
